import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Button } from "./ui/button";

const FAQ = () => {
  const faqs = [
    {
      question: "What is Integro Clinics?",
      answer: "Integro Clinics is a UK-based online clinic specialising in medical cannabis via secure video appointments and nationwide medication delivery.",
    },
    {
      question: "Who is eligible?",
      answer: "Patients with a diagnosed medical condition who have tried at least two conventional treatments without adequate benefit. You must be 21 or older.",
    },
    {
      question: "Do I need a GP referral?",
      answer: "No. You can apply directly through our eligibility checker without a GP referral. We will require access to your relevant medical records to support your clinical assessment.",
    },
    {
      question: "How do I get started?",
      answer: "Complete the eligibility checker on our website. Our clinical administration team will contact you to arrange your consultation if appropriate.",
    },
    {
      question: "What happens during a video consultation?",
      answer: "A specialist doctor reviews your medical history, discusses your symptoms, and explores treatment options with you.",
    },
    {
      question: "How much does treatment cost?",
      answer: "Clinical consultations are provided at no charge. A £4.99 flat fee applies per prescription. Your clinician will discuss any costs with you during your assessment.",
    },
  ];

  return (
    <section className="py-20 bg-[#f4f7fa]" id="faqs">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#012d5c] mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about medical cannabis and our service.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6 lg:p-10 border border-gray-100">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-lg font-semibold text-[#005eb8] hover:text-[#012d5c] text-left">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed text-base">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="mt-12 text-center bg-[#012d5c] text-white p-8 rounded-lg">
          <h3 className="text-2xl font-bold mb-4">Still have questions?</h3>
          <p className="mb-6 opacity-90">Our patient services team is available to help with any queries.</p>
          <Button 
            className="bg-[#4caf50] hover:bg-[#3d8b40] text-white px-8 py-6 rounded-lg text-lg font-bold"
            onClick={() => window.location.href = "mailto:office@integroclinics.com"}
          >
            Contact Support
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
